import { ReactNode } from 'react';

import { MainContent, PageContainer } from './styles';

interface CameraLayoutProps {
	children: ReactNode;
}

export default function CameraLayout({ children }: CameraLayoutProps) {
	return <PageContainer>{children}</PageContainer>;
}

export { MainContent };
